import { render, staticRenderFns } from "./breadcrumbpage.vue?vue&type=template&id=3bdfc029"
import script from "./breadcrumbpage.vue?vue&type=script&lang=js"
export * from "./breadcrumbpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports